"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basePath = void 0;
exports.fetchData = fetchData;
exports.host = exports.getQueryParams = exports.getItemLabel = void 0;
var _logger = require("../logger");
var _catchPromiseError = require("./catchPromiseError");
var _getUrl = require("./getUrl");
/* eslint-disable @typescript-eslint/naming-convention -- using params names defined by external libs */

const utilityName = 'azureGeocodingSearch';
const catchError = async promise => (0, _catchPromiseError.catchPromiseError)(promise, `Error in ${utilityName}`);
const basePath = exports.basePath = '/search/address/json';
const host = exports.host = 'https://atlas.microsoft.com';
const getQueryParams = (searchText, {
  mapAccount,
  tenant
}, maxDisplayedSearchResults) => ({
  'api-version': '1.0',
  countrySet: tenant.toUpperCase(),
  // 'CZ,SK'
  query: searchText,
  limit: maxDisplayedSearchResults,
  // TO-DO: replace with AAD token headers
  'subscription-key': mapAccount.credentials
});
exports.getQueryParams = getQueryParams;
const getItemLabel = address => address.freeformAddress ?? '';
exports.getItemLabel = getItemLabel;
const transformData = data => {
  (0, _logger.logDebug)(`${utilityName} transformData(): data before transformation:\n\t`, data);
  const results = (data?.results ?? []).map(item => {
    const {
      address,
      id,
      position: {
        lat: latitude,
        lon: longitude
      }
    } = item;
    return {
      id,
      label: getItemLabel(address),
      position: {
        latitude,
        longitude
      }
    };
  });
  (0, _logger.logInfo)(`${utilityName}: loaded data after transformation:\n\t`, results);
  return {
    results
  };
};
async function fetchData(options) {
  (0, _logger.logInfo)(`${utilityName}: Loading data ...`);
  const promise = catchError((0, _getUrl.getUrl)(options));
  const data = await promise;
  return transformData(data);
}